var map = {
	"./01-EZ Staking.png": 44744,
	"./02-Imerator.co.png": 27718,
	"./03-POSTHUMAN ∞ DVS.png": 41722,
	"./04-Provalidator.png": 67910,
	"./05-SmartNodes.png": 89868,
	"./06-Stakecito.png": 66594,
	"./07-StakeLab.png": 9734,
	"./08-Swiss Staking AG.png": 93873,
	"./09-BasBlock.png": 58003,
	"./10-Citadel one.png": 71723,
	"./11-Golden Ratio Staking.png": 96541,
	"./12-Vitwit.png": 72347,
	"./13-NosNodes.png": 12921,
	"./14-Frens Validator.png": 19815,
	"./15-Allnodes.png": 51951,
	"./16-iCosmosDAO.png": 29462,
	"./17-Ericet the Dev.png": 26912,
	"./18-Cosmos Spaces Validator.png": 99393,
	"./19-GATA DAO.png": 26658,
	"./20-Expanding space.png": 31064,
	"./21-kingnodes.png": 74724,
	"./22-Lavender.Five.png": 45664,
	"./23-KlubStaking.png": 79073,
	"./24-P2PValidator.png": 23730,
	"./25-NodeStake.png": 34307,
	"./26-NodeOf Cosmonauts.png": 6572,
	"./27-Polkachu.png": 95142,
	"./28-RHINO.png": 46686,
	"./29-SilentNodes.png": 31168,
	"./30-StakeFrites.png": 54445,
	"./31-TC Network.png": 12761,
	"./32-StakeRun.png": 99144,
	"./33-0base.vc.png": 82212,
	"./34-01.png": 30508,
	"./35-DragonStake.png": 39495,
	"./36-Disperze.png": 92002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52262;